module.exports = __webpack_public_path__ + "static/img/解决方案-矿山全场景AI视频识别解决方案-综采面智能监控.d1f684ba.png";